/* eslint-disable prefer-default-export */
import Field from './Field'

import './form.scss'

export default Field
